/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { GetAllInfotexteQuery as AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteQuery } from '../models/ace/xFound/Portal/Core/CAQ/Infotext/Queries/get-all-infotexte-query';
import { GetAllInfotexteResponse as AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse } from '../models/ace/xFound/Portal/Core/CAQ/Infotext/Queries/get-all-infotexte-response';

@Injectable({
providedIn: 'root',
})

export class InfotextService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiInfotextGet
   */
  static readonly ApiInfotextGetPath = '/api/Infotext';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInfotextGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInfotextGet$Plain$Response(params?: {
    query?: AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InfotextService.ApiInfotextGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInfotextGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInfotextGet$Plain(params?: {
    query?: AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteQuery;
  }): Observable<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse> {

    return this.apiInfotextGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse>) => r.body as AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInfotextGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInfotextGet$Response(params?: {
    query?: AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InfotextService.ApiInfotextGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiInfotextGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInfotextGet(params?: {
    query?: AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteQuery;
  }): Observable<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse> {

    return this.apiInfotextGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse>) => r.body as AceXFoundPortalCoreCaqInfotextQueriesGetAllInfotexteResponse)
    );
  }

}